import React from "react"; // Adjust import paths as necessary

import PrimaryButton, { GhostButton } from "@/components/bild/Button/Button";
import { Checkbox } from "@/components/bild/Checkbox";
import { Participant, RegistrationFormInteractionOutro } from "@/service/Model";
import { Icons } from "@/styles";

import * as Styled from "./styles";

type DataOptInProps = {
  formData: Partial<Participant>;
  onChange: (data: Partial<Participant>) => void;
  onBack: () => void;
  onSubmit: () => void;
  outro: RegistrationFormInteractionOutro;
  hansId?: string;
  hansIdExists?: boolean;
};

const DataOptIn: React.FC<DataOptInProps> = ({
  formData,
  onChange,
  onBack,
  onSubmit,
  outro: {
    advertisementOptIn,
    hansIdOptIn,
    termsAndConditionsLink,
    privacyPolicyLink,
  },
  hansId,
  hansIdExists,
}: DataOptInProps) => {
  const showHansIdOptIn = hansIdOptIn && hansId && !hansIdExists;

  const handleCheckChange = (
    name: "advertisementOptIn" | "hansIdOptIn",
    checked: boolean
  ) => {
    onChange({ [name]: checked });
  };

  return (
    <>
      <Styled.Headline>
        <span>
          Bei Absendung Ihrer Daten erklären Sie sich mit den{" "}
          <a href={termsAndConditionsLink} rel="noreferrer" target="_blank">
            Teilnahmebedingungen
          </a>{" "}
          einverstanden. Hinweise zum{" "}
          <a href={privacyPolicyLink} rel="noreferrer" target="_blank">
            Datenschutz
          </a>
        </span>
      </Styled.Headline>
      {(showHansIdOptIn || advertisementOptIn) && (
        <Styled.Subheader>Datenverarbeitung</Styled.Subheader>
      )}

      {advertisementOptIn && (
        <Styled.CheckboxWrapper>
          <Checkbox
            dataQA="outro.lightPoll:advertisementOptIn"
            checked={formData.advertisementOptIn || false}
            onChange={(checked) =>
              handleCheckChange("advertisementOptIn", checked)
            }
            label="Ja, ich möchte, dass die Axel Springer SE mir Newsletter per E-Mail und/oder Push-Nachrichten mit Produktangeboten und/oder Medienangeboten der Axel Springer SE zuschickt. Meine Einwilligung kann ich jederzeit widerrufen."
          ></Checkbox>
        </Styled.CheckboxWrapper>
      )}

      {showHansIdOptIn && (
        <Styled.CheckboxWrapper>
          <Checkbox
            dataQA="outro.lightPoll:hansId"
            checked={formData.hansIdOptIn || false}
            onChange={(checked) => handleCheckChange("hansIdOptIn", checked)}
            label='Meine E-Mail-Adresse darf zum Zwecke des Retargeting in pseudonymisierter Form mit E-Mail-Adressen von Werbepartnern des Vermarkters der Axel Springer SE abgeglichen werden, wenn ich dem jeweiligen Werbepartner ebenfalls meine Einwilligung (z.B. auf dessen Website) hierfür erteilt habe und kein Pur-Abo abgeschlossen habe. Meine Einwilligung kann ich jederzeit unter dem Link „Widerruf Nutzerkennungen" durch Widerruf "Axel Springer Nutzerkennung" am Ende der Website widerrufen. Nähere Informationen zu den Verarbeitungen, meinen Rechten und den Rollen der Axel Springer SE, dem Vermarkter Media Impact und den Werbetreibenden als gemeinsam Verantwortliche finde ich in der Datenschutzerklärung.'
          ></Checkbox>
        </Styled.CheckboxWrapper>
      )}

      <Styled.ButtonWrapper>
        <PrimaryButton
          dataQA="outro.lightPoll:submit"
          disabled={false}
          label="Absenden und Teilnehmen"
          onClick={onSubmit}
        />
        <GhostButton
          dataQA="outro.lightPoll:back"
          disabled={false}
          icon={Icons.PageLeft}
          iconPosition="left"
          label="Zurück"
          onClick={onBack}
        />
      </Styled.ButtonWrapper>
    </>
  );
};

export default DataOptIn;
